<template>
  <div
    style="overflow-y: scroll;  width: 100%;
      height: 100%;"
  >
    <b-container fluid>
      <b-row class="mt-5">
        <b-col offset="sm-1" class="col-1">
          <div>
            <svg
              width="50"
              height="48"
              viewBox="0 0 50 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="5.7" cy="43.3" r="4.7" fill="#5B5B5B" />
              <circle cx="5.7" cy="24.5" r="4.7" fill="#5B5B5B" />
              <circle cx="5.7" cy="5.7" r="4.7" fill="#5B5B5B" />
              <circle cx="24.5" cy="43.3" r="4.7" fill="#5B5B5B" />
              <circle cx="24.5" cy="24.5" r="4.7" fill="#5B5B5B" />
              <circle cx="24.5" cy="5.7" r="4.7" fill="#5B5B5B" />
              <circle cx="43.3" cy="43.3" r="4.7" fill="#5B5B5B" />
              <circle cx="43.3" cy="24.5" r="4.7" fill="#5B5B5B" />
              <circle cx="43.3" cy="5.7" r="4.7" fill="#5B5B5B" />
            </svg>
          </div>
        </b-col>
        <b-col class="col-3">
          <div style="display: flex">
            <svg
              width="65"
              height="48"
              viewBox="0 0 65 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M63.2549 7.54388C62.8839 6.1082 62.1602 4.79933 61.1558 3.74761C60.1515 2.6959 58.9015 1.93803 57.5304 1.54948C52.5109 0.116028 32.3089 0.116028 32.3089 0.116028C32.3089 0.116028 12.106 0.159417 7.08643 1.59287C5.71531 1.98144 4.46534 2.73935 3.46098 3.79112C2.45662 4.84288 1.73291 6.1518 1.36194 7.58753C-0.156354 16.9264 -0.745327 31.1566 1.40363 40.1219C1.77464 41.5576 2.49836 42.8665 3.50272 43.9182C4.50708 44.9699 5.75703 45.7278 7.12812 46.1163C12.1477 47.5498 32.3501 47.5498 32.3501 47.5498C32.3501 47.5498 52.5523 47.5498 57.5716 46.1163C58.9427 45.7278 60.1928 44.97 61.1972 43.9182C62.2016 42.8665 62.9253 41.5576 63.2964 40.1219C64.8978 30.7698 65.3912 16.5486 63.2549 7.54414V7.54388Z"
                fill="#FF0000"
              />
              <path
                d="M25.873 34.6133L43.1217 23.8329L25.8733 13.0525L25.873 34.6133Z"
                fill="white"
              />
            </svg>
            <h1 class="ml-3">Tube View</h1>
          </div>
        </b-col>
        <b-col class="col-2 offset-2">
          <svg
            class="ml-1"
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M50 24.1379V44.8276C50 46.1994 49.4551 47.515 48.485 48.485C47.515 49.4551 46.1994 50 44.8276 50H5.17241C3.8006 50 2.48498 49.4551 1.51497 48.485C0.544949 47.515 0 46.1994 0 44.8276L0 5.17241C0 3.8006 0.544949 2.48498 1.51497 1.51497C2.48498 0.544949 3.8006 0 5.17241 0L25.8621 0C26.548 0 27.2058 0.272475 27.6908 0.757483C28.1758 1.24249 28.4483 1.9003 28.4483 2.58621C28.4483 3.27211 28.1758 3.92992 27.6908 4.41493C27.2058 4.89994 26.548 5.17241 25.8621 5.17241H6.89655C6.4397 5.17378 6.00195 5.35587 5.67891 5.67891C5.35587 6.00195 5.17378 6.4397 5.17241 6.89655V43.1034C5.17378 43.5603 5.35587 43.998 5.67891 44.3211C6.00195 44.6441 6.4397 44.8262 6.89655 44.8276H43.1034C43.5603 44.8262 43.998 44.6441 44.3211 44.3211C44.6441 43.998 44.8262 43.5603 44.8276 43.1034V24.1379C44.8276 23.452 45.1001 22.7942 45.5851 22.3092C46.0701 21.8242 46.7279 21.5517 47.4138 21.5517C48.0997 21.5517 48.7575 21.8242 49.2425 22.3092C49.7275 22.7942 50 23.452 50 24.1379Z"
              fill="#5B5B5B"
            />
            <path
              d="M50.0002 1.72414V13.7931C50.0002 14.479 49.7277 15.1368 49.2427 15.6218C48.7577 16.1068 48.0999 16.3793 47.414 16.3793C46.7281 16.3793 46.0703 16.1068 45.5852 15.6218C45.1002 15.1368 44.8278 14.479 44.8278 13.7931V8.82759L29.276 24.3793C28.7858 24.8362 28.1373 25.0849 27.4673 25.073C26.7973 25.0612 26.1581 24.7898 25.6842 24.316C25.2104 23.8421 24.939 23.2029 24.9272 22.5329C24.9153 21.8629 25.164 21.2144 25.6209 20.7242L41.1726 5.17242H36.2071C35.5212 5.17242 34.8634 4.89994 34.3784 4.41494C33.8933 3.92993 33.6209 3.27211 33.6209 2.58621C33.6209 1.9003 33.8933 1.24249 34.3784 0.757483C34.8634 0.272475 35.5212 0 36.2071 0L48.276 0C48.7329 0.00136442 49.1706 0.183452 49.4937 0.506496C49.8167 0.82954 49.9988 1.26729 50.0002 1.72414Z"
              fill="#5B5B5B"
            />
          </svg>
          <svg
            class="ml-4"
            width="46"
            height="50"
            viewBox="0 0 46 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.8518 30.7321L13.6063 30.5881L13.4015 30.7858C12.0126 32.1266 10.1612 32.9583 8.11765 32.9583C3.85843 32.9583 0.375 29.3967 0.375 25C0.375 20.6035 3.85809 17.042 8.11703 17.0417C10.0819 17.0449 11.9727 17.8209 13.4002 19.2129L13.605 19.4126L13.8517 19.2679L30.0627 9.75958L30.2777 9.63345L30.2446 9.38636C30.2367 9.32708 30.2287 9.26907 30.2208 9.21204C30.1782 8.90406 30.1397 8.62513 30.1397 8.33333C30.1397 3.93666 33.6231 0.375 37.8824 0.375C42.1416 0.375 45.625 3.93666 45.625 8.33333C45.625 12.73 42.1416 16.2917 37.8824 16.2917C35.8388 16.2917 33.9874 15.46 32.5985 14.1191L32.3937 13.9215L32.1483 14.0654L15.9373 23.5738L15.7223 23.6999L15.7554 23.947C15.7633 24.0063 15.7713 24.0643 15.7792 24.1213C15.8218 24.4293 15.8603 24.7082 15.8603 25C15.8603 25.2918 15.8218 25.5707 15.7792 25.8787C15.7713 25.9357 15.7633 25.9937 15.7554 26.053L15.7223 26.3001L15.9373 26.4262L32.1483 35.9346L32.3937 36.0785L32.5985 35.8809C33.9874 34.54 35.8388 33.7083 37.8824 33.7083C42.1416 33.7083 45.625 37.27 45.625 41.6667C45.625 46.0633 42.1416 49.625 37.8824 49.625C33.6231 49.625 30.1397 46.0633 30.1397 41.6667C30.1397 41.3733 30.1787 41.0926 30.2215 40.7844C30.2291 40.7295 30.2369 40.6737 30.2446 40.6168L30.2779 40.3695L30.0627 40.2432L13.8518 30.7321Z"
              fill="#5B5B5B"
              stroke="#5B5B5B"
              stroke-width="0.75"
            />
          </svg>
          <svg
            class="ml-4"
            width="46"
            height="51"
            viewBox="0 0 46 51"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="28.7692" cy="5.76923" r="5.76923" fill="#5B5B5B" />
            <circle cx="28.7692" cy="24.9999" r="5.76923" fill="#5B5B5B" />
            <circle cx="28.7692" cy="44.2307" r="5.76923" fill="#5B5B5B" />
          </svg>
        </b-col>
        <b-col class="col-3">
          <span>
            <h3>Add Note</h3>
          </span>
          <hr />
          <span>
            <p>Add your Note Here</p>
          </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-4 offset-sm-1">
          <iframe width="1070px" height="560px" :src="video"> </iframe>
          <!--- <img
            :height="560"
            :width="1070"
            :title="video"
            :src="img"
            class="mr-1"
          /> --->
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col offset="sm-1" class="col-3">
          <h2 class="bold">Sales Force Admin</h2>
        </b-col>
      </b-row>
      <b-row>
        <b-col offset="sm-1" class="col-6">
          <p>Views 1.5 Million 2 hours ago</p>
        </b-col>
        <b-col>
          <p class="offset-2 col-3">01:05:30</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col offset="sm-1" class="col-6">
          <p>
            You put the "I" in impact. You bring innovation to life, bridging
            the gap between business requirements...
          </p>
        </b-col>
        <b-col class="col-2 offset-1 bottom-icon">
          <svg
            class="info"
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M28.0858 2.25H6.07324C3.96507 2.25 2.25 4.13658 2.25 6.45557V28.6304C2.25 30.9494 3.96507 32.8359 6.07324 32.8359H25.4212C26.5652 32.8359 27.6408 32.3459 28.4499 31.4559L30.6545 29.0308C31.4636 28.1409 31.9091 26.9577 31.9091 25.6992V6.45557C31.9091 4.13658 30.194 2.25 28.0858 2.25ZM6.07324 4.28906H28.0858C29.1719 4.28906 30.0554 5.26093 30.0554 6.45557V9.38672H4.10369V6.45557C4.10369 5.26093 4.98721 4.28906 6.07324 4.28906ZM4.10369 28.6304V11.4258H30.0554V24.6797H27.159C25.6897 24.6797 24.4943 25.9946 24.4943 27.6108V30.7969H6.07324C4.98721 30.7969 4.10369 29.825 4.10369 28.6304ZM29.3438 27.589L27.1391 30.0141C26.9088 30.2675 26.6404 30.4637 26.348 30.5963V27.6108C26.348 27.1189 26.7118 26.7188 27.159 26.7188H29.8731C29.7525 27.0403 29.5741 27.3356 29.3438 27.589Z"
              fill="#0A1A3A"
            />
            <path
              d="M26.9561 15.5384C26.9561 14.9739 26.4568 14.5162 25.8409 14.5162H7.99915C7.38326 14.5162 6.88403 14.9739 6.88403 15.5384C6.88403 16.1029 7.38326 16.5606 7.99915 16.5606H25.8409C26.4568 16.5606 26.9561 16.1029 26.9561 15.5384Z"
              fill="#0A1A3A"
            />
            <path
              d="M23.6107 19.6271H10.2294C9.61348 19.6271 9.11426 20.0848 9.11426 20.6493C9.11426 21.2138 9.61348 21.6714 10.2294 21.6714H23.6107C24.2266 21.6714 24.7258 21.2138 24.7258 20.6493C24.7258 20.0848 24.2266 19.6271 23.6107 19.6271Z"
              fill="#0A1A3A"
            />
          </svg>
          <svg
            @click="hideOverlay"
            class="hide"
            width="47"
            height="47"
            viewBox="0 0 57 57"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M30.2792 39.1394C30.2792 40.116 31.0274 40.9058 31.9567 40.9058C32.8781 40.9035 33.6353 40.116 33.6353 39.1394L33.6353 35.483L40.4059 42.257C41.0607 42.9129 42.1205 42.9129 42.7753 42.257C43.4301 41.6022 43.4301 40.539 42.7753 39.8842L36.0373 33.1485L39.6769 33.1485C40.668 33.1462 41.4668 32.3958 41.4668 31.471C41.4668 30.544 40.668 29.7947 39.6769 29.7947L32.0703 29.7947C31.0792 29.7947 30.2815 30.5429 30.2781 31.471C30.2815 31.4958 30.2849 31.5149 30.2882 31.5397C30.2849 31.5712 30.2781 31.6049 30.2781 31.6375L30.2781 39.1394L30.2792 39.1394Z"
              fill="#0A1A3A"
            />
            <path
              d="M14.2219 42.2582L20.9891 35.4842L20.9891 39.1407C20.9891 40.1172 21.7452 40.9048 22.6688 40.907C23.5959 40.907 24.3452 40.1172 24.3452 39.1407L24.3474 31.6377C24.3474 31.605 24.3384 31.5713 24.3362 31.5398C24.3384 31.5161 24.3429 31.497 24.3452 31.4711C24.3429 30.543 23.5441 29.7948 22.5541 29.7948L14.9464 29.7948C13.9575 29.7948 13.1576 30.5441 13.1576 31.4711C13.1576 32.3959 13.9575 33.1464 14.9464 33.1486L18.586 33.1486L11.848 39.8843C11.1955 40.5391 11.1955 41.6023 11.848 42.2571C12.5039 42.9141 13.5649 42.9141 14.2219 42.2582Z"
              fill="#0A1A3A"
            />
            <path
              d="M40.4047 12.3686L33.6341 19.138L33.6341 15.4816C33.6341 14.5084 32.8769 13.7209 31.9555 13.7175C31.0262 13.7175 30.278 14.5084 30.278 15.4816L30.278 22.9869C30.278 23.0195 30.2848 23.0532 30.2881 23.0825C30.2848 23.1061 30.2814 23.1286 30.278 23.1522C30.2814 24.0815 31.0791 24.8297 32.0691 24.8297L39.6756 24.8297C40.6668 24.8297 41.4656 24.0815 41.4656 23.1522C41.4656 22.2286 40.6668 21.4759 39.6756 21.4737L36.0361 21.4737L42.774 14.7379C43.4288 14.0843 43.4288 13.0233 42.774 12.3697C42.1193 11.7104 41.0595 11.7104 40.4047 12.3686Z"
              fill="#0A1A3A"
            />
            <path
              d="M18.586 21.4738L14.9475 21.4738C13.9586 21.476 13.1587 22.2287 13.1587 23.1524C13.1587 24.0817 13.9586 24.8298 14.9475 24.8298L22.5541 24.8298C23.5441 24.8298 24.3429 24.0817 24.3452 23.1524C24.3429 23.1287 24.3384 23.1062 24.3362 23.0826C24.3384 23.0534 24.3474 23.0207 24.3474 22.987L24.3452 15.4806C24.3452 14.5074 23.5959 13.7165 22.6688 13.7165C21.7452 13.7199 20.9891 14.5074 20.9891 15.4806L20.9891 19.137L14.2219 12.3687C13.5648 11.7105 12.5039 11.7105 11.848 12.3687C11.1955 13.0223 11.1955 14.0833 11.848 14.7369L18.586 21.4738Z"
              fill="#0A1A3A"
            />
          </svg>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  name: "overlay-tube-view",
  props: ["video", "img"],
  data() {
    return {
      loaded: false
    };
  },
  mounted() {
    console.log("video in overlay", this.video, this.img);
    this.loaded = true;
  },
  methods: {
    hideOverlay() {
      this.$emit("hideOverlay");
    }
  }
};
</script>
<style lang="scss" scoped>
.bottom-icon {
  .info {
    cursor: pointer;
  }
  .hide {
    cursor: pointer;
  }
}
</style>
